import { getTransitionAnimationMessage } from '../../utils/transitionAnimationUtils';
import { delay } from '../../utils/utils';
export const CLEAR_TRANSITION_ANIMATION = 'CLEAR_TRANSITION_ANIMATION';
export const START_TRANSITION_ANIMATION = 'START_TRANSITION_ANIMATION';
export const END_TRANSITION_ANIMATION = 'END_TRANSITION_ANIMATION';
export function clearTransitionAnimation() {
    return {
        type: CLEAR_TRANSITION_ANIMATION
    };
}
function startTransitionAnimation(transitionSceneType, transitionAnimationMessage) {
    return {
        type: START_TRANSITION_ANIMATION,
        payload: { transitionSceneType, transitionAnimationMessage }
    };
}
export function thunkStartTransitionAnimation(transitionSceneType, messageFromServer) {
    return async function (dispatch, getState) {
        const transitionAnimationMessage = getTransitionAnimationMessage(getState().selfData.isPowerPlayer, messageFromServer);
        dispatch(startTransitionAnimation(transitionSceneType, transitionAnimationMessage));
    };
}
function endTransitionAnimation() {
    return {
        type: END_TRANSITION_ANIMATION
    };
}
export function thunkEndTransitionAnimation() {
    return async function (dispatch) {
        // By adding a tiny delay, the animation should begin only after any expensive room initialization code has
        // finished running, which in theory will make the animation smoother and not get truncated:
        await delay(0);
        dispatch(endTransitionAnimation());
    };
}
